<template lang="html">

  <section class="trips">
    <div class="pageHeading">
      <h2>Trips</h2>
    </div>


    <v-container grid-list-md text-xs-center fill-height>
      <v-layout row wrap>
        <v-flex xs12 md12>

          <v-card elevation="1">

            <v-card-title primary-title
                          :class="{'tripListItemHidden': panelIndex !== null}">
              <v-flex xs6 text-xs-left>
                <h3 class="headline mb-0">Trip List</h3>

              </v-flex>

              <v-flex xs6 text-xs-center>
                <v-text-field
                        v-model="tripSearch"
                        label="Search"
                        append-icon="search"
                ></v-text-field>
              </v-flex>



            </v-card-title>


            <v-container @click="editTrip(trip)" v-for="trip in filteredTripList" class="tripListItem"  style="border-top: lightgray 1px solid;
    cursor: pointer;"  >

              <v-layout row wrap >
                <v-flex xs2 md2 >
                  <span class="topTextBottomLabels">{{trip.tripID}}</span>
                  <br/>
                  <strong class="bottomLabels" v-if="trip.disabled == true" style="color:red">Disabled</strong>
                  <strong class="bottomLabels" v-else>Trip ID</strong>

                </v-flex>
                <v-flex xs10 md6>
                  <span class="topTextBottomLabels">{{trip.tripName}}</span>
                  <br/>
                  <strong class="bottomLabels">Trip Name</strong>
                </v-flex>
                <v-flex xs4 md1>
                  <span class="topTextBottomLabels">{{getPartCount(trip._id)}}</span>
                  <br/>
                  <strong class="bottomLabels">Participants</strong>
                </v-flex>
                <v-flex xs5 md2>
                  <span class="topTextBottomLabels">{{trip.departDate | moment("MM/DD/YYYY")}}</span>
                  <br/>
                  <strong class="bottomLabels">Departure</strong>
                </v-flex>
                <v-flex xs3 md1>
                  <span class="topTextBottomLabels">${{trip.quadPrice}}</span>
                  <br/>
                  <strong class="bottomLabels">Cost</strong>
                </v-flex>
              </v-layout>

            </v-container>



          </v-card>


        </v-flex>
        <v-flex xs12 md6>

        </v-flex>
      </v-layout>
    </v-container>


    <table-component v-if="1==2" table-class="fullWidthTable" filter-input-class="fullWidthTableFilter" filter-placeholder="Filter Results" :show-caption="false"
            :data="tripsInSystem"
            sort-by="tripID"
            sort-order="asc"
    >
      <table-column show="tripID" label="Trip ID"></table-column>
      <table-column show="tripName" label="Trip name"></table-column>
      <table-column show="tripParticipants" label="Trip Participants" data-type="date:DD/MM/YYYY"></table-column>
      <table-column show="departDate" label="Trip Departure Date" data-type="date:DD/MM/YYYY"></table-column>
      <table-column show="tripCost" label="Trip Cost"></table-column>
      <table-column label="" :sortable="false" :filterable="false">
        <template slot-scope="row">
          <!--<a :href="`#${row.firstName}`">Edit</a>-->

          <v-btn small color="primary">Participants</v-btn>
          <v-btn small color="primary">Edit</v-btn>
          <v-btn small color="error">Delete</v-btn>
        </template>
      </table-column>
    </table-component>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'trips',
    props: [],
    mounted() {
        var vueThis = this;
        this.$services.trips.find().then((result) => {
            vueThis.tripsInSystem = result.data
            console.log('test is', result)
        })
    },
      watch: {
          panelIndex: function() {
              console.log("watch panelIndex id: " + this.panelIndex)
              //if this panelIndex matches this component's index.. do stuff since we're selected
          }
      },
    data() {
      return {
          tripSearch: '',
          openTest: false,
          panelIndex: null,
          depositValue: 100,
          installment1: 100,
          installment2: 50,
          installment3: 0,
          installment4: 0,
          tripsInSystem: []
          /*
          [
          { tripID: '2312', tripName: 'Test One', tripParticipants: '32', tripDepartureDate: '04/10/1740', tripCost: '720.00' },
          { tripID: '2143', tripName: 'Another test', tripParticipants: '12', tripDepartureDate: '04/10/1140', tripCost: '172.00' },
          { tripID: '5444', tripName: 'dfasf adsfasd ', tripParticipants: '42', tripDepartureDate: '04/10/1240', tripCost: '272.00' },
          { tripID: '1212', tripName: 'Lenndfasdfs on', tripParticipants: '11', tripDepartureDate: '046/10/1940', tripCost: '372.00' },
          { tripID: '4545', tripName: 'dfa fffffff', tripParticipants: '22', tripDepartureDate: '04/15/1940', tripCost: '472.00' },
          { tripID: '1020', tripName: 'ssssss sfsdfsf', tripParticipants: '33', tripDepartureDate: '02/10/1940', tripCost: '572.00' },
          ]
           */
      }
    },
    methods: {
        editTrip(trip) {
            if(this.$feathers.get('user').permissions[0] == "admin" || this.$feathers.get('user').permissions[0] == "sales")
            this.$router.push('/UpdateTrip/'+trip._id)
        },
        getPartCount(tripID) {
            //console.log('get part says', this.$structuredData.participants.filter( participant => participant.TripID === tripID))
            return this.$structuredData.participants.filter( participant => participant.TripID === tripID).length
        }
    },
    computed: {
        filteredTripList () {
            if(this.tripSearch.trim().length == 0) {
                console.log('not filtering')
                return this.tripsInSystem;
            }

            var toReturn = []
            var vueThis = this;
            toReturn = this.tripsInSystem.filter(function( trip ) {
                console.log('index of', trip.tripName.indexOf(vueThis.tripSearch))
                //return (trip.tripName.indexOf(vueThis.tripSearch) != -1)
                //return (trip.tripID.indexOf(vueThis.tripSearch) != -1)
                return (trip.tripID.indexOf(vueThis.tripSearch) != -1 || trip.tripName.indexOf(vueThis.tripSearch) != -1)
            });

            return toReturn

        }

    }
}
</script>

<style scoped lang="scss">
  .trips {

  }


  .BottomLabels {
    text-decoration: overline;
    font-size: 12px;
    position: relative;
    top: -3px;
  }

  .topTextBottomLabels {
    font-size: 15px;
  }

  .tripListItemOpen{
    background-color: #1976d29e !important;
    color: white;
  }

  .tripListItemHidden{
    display: none;
  }

  .bottomLabels {
    text-decoration: overline;
    font-size: 12px !important;
    position: relative;
    top: -3px;
  }

  .bottomLabelsNoUnderline{
    font-size: 12px;
    position: relative;
    top: -3px;
  }

  .teststyle{
    padding: 10px;
    border-top: 2px solid darkgrey;
    background-color: #fff;
    color: rgba(0,0,0,.87);
  }
  .teststyle:hover {
    //padding: 20px;
    cursor: pointer;
    background: lightgrey;
  }



</style>
